import React from 'react';
// import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import _ from 'underscore';

import { acAxiosRequest } from '../actions/acAxiosRequest'
import { acMobToggle } from '../actions/acMobToggle';
// import { acToggleMobile } from '../actions/acToggleMobile'
import { acConSizeChange } from '../actions/acConSizeChange'

import StatisticiNumere from '../containers/StatisticiNumere'
import MidListDDRunde from './MidListDDRunde';
import RandomNumbers from '../containers/RandomNumbers'
import Paytable from '../containers/Paytable'
// import LottoLive from '../theme/LottoLive';


class MidListDD extends React.Component {

    constructor() {
        super();
        this.state = {
            coun: 0,
            coteMob: false,
            loading: '',
        };

    }
    componentDidUpdate(prevProps, prevState) {

        if (this.refColMid) {
            if ((this.props.conSizeChange.colMidH !== this.refColMid.offsetHeight) || (this.props.conSizeChange.colMidW !== this.refColMid.offsetWidth)) {
                var dimensions = this.refColMid
                this.props.acConSizeChange({
                    colMidH: dimensions.offsetHeight,
                    colMidW: dimensions.offsetWidth
                })
            }
        }

        // console.log('aaaaaaaaaaaaaaa', this.state.loading, this.props.runde);
        // if ((this.props.loading === 'RUNDE') && (this.props.runde && prevProps.runde) && (this.props.runde[0].selectedLot !== prevProps.runde[0].selectedLot)) {
        //     if (this.state.loading !== 'active') {
        //         this.setState({ loading: 'active' });
        //     }
        // } else {
        //     if (this.state.loading !== '') {
        //         this.setState({ loading: '' });
        //     }
        // }

    }
    // millisToMinutesAndSeconds(millis) {
    //     var minutes = Math.floor(millis / 60000);
    //     var seconds = ((millis % 60000) / 1000).toFixed(0);
    //     return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
    // }
    odds() {
        var odds = []
        for (var i = 0; i < this.props.activeLot.odds.length; i++) {
            odds.push(<td key={i}>{this.props.activeLot.odds[i]}</td>)
        }
        return odds;
    }
    activeConBile(val) {
        // console.log(val);
    }
    toggleMobile() {
        if (this.props.mobToggle === true) {
            return 'mob'
        } else {
            return ''
        }
    }
    nrOdds() {
        var arr = []
        for (let i = 0; i < this.props.activeLot.nr_odds; i++) {
            arr.push(<th key={i}>{i + 1}</th>)
        }
        return arr
    }
    toggleOverlay() {
        this.props.acMobToggle(!this.props.mobToggle)
    }
    loadingActive() {
        if (this.props.loading === 'RUNDE') {
            return 'active'
        }
        else {
            return ''
        }
    }

    coteShowMob() {
        this.setState({ coteMob: !this.state.coteMob })
    }
    coteShowMobClass() {
        if (this.state.coteMob === false) {
            return 'dn';
        }
        else if (this.state.coteMob === true) {
            return '';
        }
    }
    _odds() {
        var odds = []
        for (var i = 0; i < this.props.activeLot.odds.length; i++) {
            if (this.props.activeLot.odds[i].slice(-3) === '000') {
                odds.push(<td key={i}>{this.props.activeLot.odds[i].slice(0, -3) + 'k'}</td>)
            } else {
                odds.push(<td key={i}>{this.props.activeLot.odds[i]}</td>)
            }
        }
        return odds;
    }
    nrStatistici() {
        if (this.props.conSizeChange.appW <= 999 && this.props.loterii) {
            return (<StatisticiNumere />)
        }
    }
    randomNumbers() {
        if (this.props.appProps.randomNumbers === true) {
            return (
                <RandomNumbers />
            )
        }
    }
    paytable() {
        if (this.props.appProps.paytable === true && this.props.activeLot !== null) {
            return (
                <Paytable />
            )
        }
    }
    render() {
        if ((this.props.activeLot !== null) && (this.props.runde !== null)) {
            return (
                <div className={"mid-list-dd " + this.toggleMobile()} ref={(f) => this.refColMid = f}>
                    <div className="mob-overlay" onClick={this.toggleOverlay.bind(this)}></div>
                    <div className={"loading " + this.loadingActive()}></div>
                    <div className="col-mid-mob-header">
                        <span>{this.props.multiLang.runda.txt}</span>
                    </div>
                    {this.nrStatistici()}
                    <table className="main">
                        {/* <thead >
                            <tr className="module-header">

                                <th colSpan="1"> */}
                        {/* <img src={"img/steaguri/" + this.props.appProps.steaguri + "/svg/" + this.props.activeLot.country_flags.toLowerCase().replace(/ /g, "_") + ".svg"} alt="" /> */}
                        {/* <span>Următoarele extrageri</span>
                                    <span onClick={this.coteShowMob.bind(this)} className="but-mob-cote">Cote</span>
                                </th>
                                {this.nrOdds()}
                            </tr>
                            <tr><th colSpan="10"></th></tr>
                        </thead> */}
                        {
                            this.props.runde.map((val, i) => {

                                return (
                                    <MidListDDRunde
                                        key={val.round_unique}
                                        index={i}
                                        rundaVal={val}
                                    />
                                )
                            })
                        }

                    </table>
                    <table className={"mob-odds " + this.coteShowMobClass()}>
                        <tbody>
                            <tr>
                                {this.nrOdds()}
                            </tr>
                            <tr>{this._odds()}</tr>
                        </tbody>
                    </table>
                    {this.randomNumbers()}
                    {this.paytable()}
                </div>
            )
        }
        else {
            return <div></div>
        }
    }
}
function mapStateToProps(state) {
    return {
        appProps: state.appProps,
        activeLot: state.activeLot,
        defaultVal: state.defaultVal,
        runde: state.runde,
        serverTime: state.serverTime,
        multiLang: state.multiLang,
        mobToggle: state.mobToggle,
        loading: state.loading,
        conSizeChange: state.conSizeChange,
        loterii: state.loterii
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acAxiosRequest: acAxiosRequest,
        acMobToggle: acMobToggle,
        // acToggleMobile: acToggleMobile,
        acConSizeChange: acConSizeChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(MidListDD);
